module.exports = __webpack_public_path__ + "zvetseni-prsou_47_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_47_before.jpg
// module id = 1342
// module chunks = 0